/**
 * Begin Again Living Ministries — Books & Devotionals data
 * ----------------------------------------------------------
 * To add or update a book, edit the BOOKS array below.
 *
 * Each entry has this shape:
 *
 *   {
 *     id: "unique-slug",                       // letters + hyphens, used for testids
 *     title: "Book Title",
 *     subtitle: "Short subtitle or tagline",   // optional
 *     description: "1-2 sentence description shown under the title.",
 *     category: "Grief Devotionals",           // must match one of CATEGORIES below
 *     cover_image: "https://...jpg",           // optional — when omitted, a styled placeholder is rendered
 *     amazon_url: "https://www.amazon.com/...", // optional — when omitted, card shows "Coming Soon" instead of "Buy on Amazon"
 *     cover_palette: "from-primary/20 to-primary/5",  // optional, only used for placeholder covers
 *     accent: "primary",                        // optional — "primary" (soft blue) or "secondary" (warm gold)
 *   }
 *
 * --- Tips for cover images ---
 *  • Upload your cover to your own image host (e.g. Imgur, S3, Cloudinary)
 *    and paste the direct image URL here.
 *  • Alternatively, on the Amazon product page, right-click the cover →
 *    "Copy image address" and paste the URL.
 *  • Recommended cover aspect ratio: 3:4 (portrait). The card will crop to fit.
 *
 * --- How "Coming Soon" works ---
 *  • If a book has BOTH `cover_image` AND `amazon_url`, it shows a clean card
 *    with the "Buy on Amazon" button — NO "Coming Soon" pill.
 *  • If either is missing, the card shows a styled placeholder with a
 *    "Coming Soon" pill so the page stays full and informative.
 */

export const CATEGORIES = [];

/**
 * AUTHOR BIO — real portrait, placeholder bio (edit any field to update).
 * --------------------------------
 *  • photo:        direct image URL (recommended: 800x800 square portrait,
 *                  warm lighting, looking slightly toward the camera).
 *                  Once you have a real headshot, host it (Imgur, S3,
 *                  Cloudinary, etc.) and paste the direct URL here.
 *  • name:         the H2 heading shown on the page. Can be either an actual
 *                  name ("Chaplain Derrick Hall") or a heading-style label
 *                  ("Resources by Chaplain Derrick") — both render correctly.
 *  • title:        optional role line shown under the H2 in soft-blue caps.
 *                  Leave as empty string ("") to hide it cleanly.
 *  • bio:          1–3 sentence introduction. Keep it warm, ministry-focused,
 *                  and written in third person — feels right next to the H2.
 *  • scripture:    optional grounding verse rendered as a left-bordered
 *                  blockquote beneath the bio. Leave as "" to hide.
 */
export const AUTHOR = {
  // Real author portrait — Chaplain Derrick (uploaded Feb 2026).
  // To swap later: replace this URL with any direct image link
  // (recommended: 800×800 square, face roughly centered).
  photo:
    "https://customer-assets.emergentagent.com/job_grief-support-care/artifacts/00xoktfv_bu05hesjl8kbroe9idjbumgoj4._SX300_CR0%2C0%2C300%2C300_.jpg",
  name: "Resources by Chaplain Derrick",
  title: "",
  bio: "Chaplain Derrick creates practical, faith-based resources to support grief care, spiritual encouragement, chaplaincy training, caregiver support, and emotional resilience.",
  scripture: "“He heals the brokenhearted and binds up their wounds.” — Psalm 147:3",
};

export const BOOKS = [
  // ===========================================
  // EXAMPLE — copy this block to add a real Amazon book
  // ===========================================
  // {
  //   id: "my-new-book",
  //   title: "My New Book Title",
  //   subtitle: "Optional Subtitle",
  //   description: "Short 1-2 sentence description of the book.",
  //   category: "Grief Devotionals",   // must match one of the CATEGORIES above
  //   cover_image: "https://m.media-amazon.com/images/P/B0XXXXXXXX.01.LZZZZZZZ.jpg",
  //   amazon_url: "https://www.amazon.com/dp/B0XXXXXXXX",
  //   accent: "primary",
  // },
];
